import { useMutation, useQueryClient } from "react-query";

import { api } from "../../utils";
import { useAuth } from "../useAuth";

export const useDeleteAsset = (queryKey: string[]) => {
    const auth = useAuth();
    const queryClient = useQueryClient();

    return useMutation(
        async (assetId: string) => {
            if (!auth.token) {
                throw new Error(
                    "Cannot delete asset without authorization token.",
                );
            }

            return await api.Asset.deleteById(assetId, auth.token);
        },
        {
            onSuccess: () => {
                queryClient.invalidateQueries(queryKey);
            },
        },
    );
};
